import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { FacilityFilterapi } from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

function* getFacilityFilterList(action) {
  try {
    const response = yield call(() => FacilityFilterapi(action.payload));
    yield put({
      type: types.FETCH_FACILITY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.FETCH_FACILITY_FAILURE, error });
    alertNotification("error", "Failed to fetch Facility Name list");
  }
}

export function* watchGetFacilityFilterSaga() {
  yield takeEvery(types.FETCH_FACILITY_REQUEST, getFacilityFilterList);
}
